import { defineComponent as _defineComponent } from 'vue'
import { computed, withDefaults } from 'vue';

type Props = {
    type?: 'info'|'warning'|'error';
    showIcon?: boolean;
    message?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NoteBox',
  props: {
    type: { default: 'info' },
    showIcon: { type: Boolean, default: false },
    message: { default: '' }
  },
  setup(__props: any) {

const props = __props as { type: 'info'|'warning'|'error', showIcon: boolean, message: string };



const backgroundClasses = computed<string>(() => {
    switch (props.type) {
        case 'warning': return 'bg-yellow-500 bg-opacity-20 border-yellow-500 text-series-yellow-400';
        case 'info': return 'bg-primary-500 bg-opacity-10 border-primary-500 text-primary-500';
        case 'error': return 'bg-red-500 bg-opacity-20 border-red-500 text-red-600';
        default: return '';
    }
});

return { __sfc: true,props, backgroundClasses }
}

})